export default __webpack_public_path__ + "static/media/Spear of the Pillars.857eac31.jpg";